import {
  COST_CENTERS_LOAD_DATA,
  COST_CENTERS_LOAD_DATA_SUCCESS,
  COST_CENTERS_LOAD_DATA_FAILED,
  COST_CENTERS_CREATION_DATA_SUCCESS,
  COST_CENTERS_UPDATE_DATA_SUCCESS,
  COST_CENTERS_DELETE_DATA_SUCCESS
} from './available'
import _, { startCase } from 'lodash'
import {RequestState} from "../../requestState";

export default {
  [COST_CENTERS_LOAD_DATA](state) {
    state.fetchAllCostCenters = RequestState.Loading;
  },
  [COST_CENTERS_LOAD_DATA_SUCCESS](state, costCenters) {
    state.fetchAllCostCenters = RequestState.Success;

    state.allCostCentersMap = {}

    costCenters.forEach(element => {
      state.allCostCentersMap[element.id] = element.title
    });

    state.costCenters = costCenters
  },
  [COST_CENTERS_LOAD_DATA_FAILED](state, error) {
    state.fetchAllCostCenters = RequestState.Failed;
  },
  [COST_CENTERS_CREATION_DATA_SUCCESS](state, newCostCenter) {
    state.costCenters.push(newCostCenter)
    state.allCostCentersMap[newCostCenter.id] = newCostCenter.title
  },
  [COST_CENTERS_UPDATE_DATA_SUCCESS](state, {oldPosition, updatedCostCenter}) {
    state.costCenters.splice(oldPosition, 1)
    state.costCenters.splice(oldPosition, 0, updatedCostCenter)

    state.allCostCentersMap[updatedCostCenter.id] = updatedCostCenter.title
  },
  [COST_CENTERS_DELETE_DATA_SUCCESS](state, positionIndex) {
    state.costCenters.splice(positionIndex, 1)

    state.allCostCentersMap = {}
    state.costCenters.forEach(element => {
      state.allCostCentersMap[element.id] = element.title
    });

  },
}



// WEBPACK FOOTER //
// ./src/store/mutations/cost-centers.js